import Link from 'next/link'

import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${themeGet('colors.text.title')};

  &:hover {
    color: ${themeGet('colors.text.body')};
  }

  > svg {
    width: 12px;
    height: 12px;
  }
`
